import styles from 'components/current-tariffs-card/components/social-tariff-banner/SocialTariffBanner.module.scss'
import { Banner } from '@boltenergy-be/design-system'
import { useTranslation } from 'react-i18next'
import Link from 'components/link/Link.tsx'
import { useStoreSelector } from 'hooks/store.ts'
import { useGetLanguage } from 'hooks/use-get-language'
import { selectCurrentAccount } from 'store/contact/slice.ts'
import dayjs from 'dayjs'
import { LANGUAGES, ServiceContractElectricity } from '@boltenergy-be/shared'

const SocialTariffBanner = ({ serviceContract }: { serviceContract: ServiceContractElectricity }) => {
  // Redux
  const account = useStoreSelector(selectCurrentAccount)

  // i18n
  const { t } = useTranslation('addresses')
  const language = useGetLanguage()

  if (
    !account?.attestations?.length ||
    !account.attestations.some((attestation) => attestation.ean === serviceContract.deliveryPoint.ean)
  ) {
    return null
  }

  return (
    <Banner
      as="section"
      type="informative"
      title={t(($) => $.myContract.socialTariff.title)}
      className={styles['social-tariff']}
      id="social-tariff"
    >
      <p>{t(($) => $.myContract.socialTariff.description)}:</p>

      <ul className="my-200">
        {account.attestations.map((attestation, index) => (
          <li key={index}>
            {dayjs(attestation.fromDate).format('DD/MM/YYYY')} {t(($) => $.myContract.socialTariff.till)}{' '}
            {dayjs(attestation.toDate).format('DD/MM/YYYY')}
          </li>
        ))}
      </ul>

      <Link
        href={
          language === LANGUAGES.NL
            ? 'https://economie.fgov.be/nl/themas/energie/energieprijzen/sociaal-tarief-voor-energie'
            : 'https://economie.fgov.be/fr/themes/energie/prix-de-lenergie/tarif-social-pour-lenergie'
        }
        external
        variant="secondary"
        className={styles['more-info']}
      >
        {t(($) => $.myContract.socialTariff.moreInfo)}
      </Link>
    </Banner>
  )
}

export default SocialTariffBanner
